import { ref } from 'vue';

import { showToastError, showToastSuccess } from '@base/helpers';

const SAVE_ERROR_MESSAGE = 'Ошибка при сохранении YAML';
const SAVE_SUCCESS_MESSAGE = 'YAML успешно сохранен';

export const useCodeViewerModal = () => {
  const isShowCodeViewer = ref(false);
  const yamlContent = ref('');
  const isSavingYaml = ref(false);

  const open = async (loader: () => Promise<string>) => {
    yamlContent.value = await loader();
    isShowCodeViewer.value = true;
  };

  const close = () => {
    isShowCodeViewer.value = false;
  };

  const save = async (yaml: string, saver: (yaml: string) => Promise<void>) => {
    isSavingYaml.value = true;

    try {
      await saver(yaml);
    } catch {
      showToastError(SAVE_ERROR_MESSAGE);
      return false;
    } finally {
      isSavingYaml.value = false;
    }

    yamlContent.value = yaml;
    isShowCodeViewer.value = false;
    showToastSuccess(SAVE_SUCCESS_MESSAGE);

    return true;
  };

  return {
    isShowCodeViewer,
    yamlContent,
    isSavingYaml,
    open,
    close,
    save,
  };
};
